import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import { useState, KeyboardEvent } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { ResultInfo } from '../../types/ResultTypes';
import { SearchTopic } from '../../enum/SearchTopics';

export interface MultiTurnProps {
  logId: string;
  results: ResultInfo[];
  topic: SearchTopic;
  onSendMessage: (
    message: string,
    current_turn: number,
    option: SearchTopic,
    parentId: string,
    previous_results: ResultInfo[]
  ) => void;
  selectedOption: SearchTopic;
  turn: number;
  disabled: boolean;
}

const MultiTurn = ({ logId, results, onSendMessage, selectedOption, turn, disabled }: MultiTurnProps) => {
  const [question, setQuestion] = useState('');

  /**
   * Clears the question and anchor element
   */
  const handleQuestionBoxClose = () => {
    setAnchorEl(null);
    setQuestion('');
  };

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleFeedbackClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleButtonSubmit = () => {
    if (question.trim()) {
      onSendMessage(question, turn, selectedOption, logId, results);
      setQuestion('');
    }
    handleQuestionBoxClose();
  };

  const handleKeyPress = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' && !e.shiftKey && !disabled) {
      e.preventDefault();
      if (question.trim()) {
        onSendMessage(question, turn, selectedOption, logId, results);
        setQuestion('');
        handleQuestionBoxClose();
      }
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', pr: 2 }}>
      <Button type="submit" variant="contained" color="primary" onClick={handleFeedbackClick}>
        Follow up
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleQuestionBoxClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div style={{ padding: '10px' }}>
          <TextField
            label="Question"
            multiline
            rows={2}
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            fullWidth
            onKeyUp={handleKeyPress}
          />
          <Button variant="contained" onClick={handleButtonSubmit} disabled={disabled} sx={{ mt: 1 }}>
            Submit
          </Button>
        </div>
      </Popover>
    </Box>
  );
};

export default MultiTurn;
